import { render, staticRenderFns } from "./MindsDB.vue?vue&type=template&id=8d86a8e0&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d86a8e0')) {
      api.createRecord('8d86a8e0', component.options)
    } else {
      api.reload('8d86a8e0', component.options)
    }
    module.hot.accept("./MindsDB.vue?vue&type=template&id=8d86a8e0&", function () {
      api.rerender('8d86a8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/partnerIcons/MindsDB.vue"
export default component.exports